import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  text: {
    marginTop: theme.spacing(2)
  }
}));

export default function Loader({ className }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      className={className}
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <CircularProgress />
      <span className={classes.text}>{t("root.loading")}...</span>
    </Box>
  );
}
